angular.module( 'acme.view.application.resources.instances', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.resources.instances.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesInstances = {
        name: 'application.resourcesInstances',
        url: '/resources/instances/:id',
        views: {
          "subview-main": {
            controller: 'ResourcesInstancesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/resources/instances/instances.tpl.html'
          }
        },
        data: {
          pageTitle: 'View Resource',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.resources.instances') !== -1);
          }
        },
        resolve: {
          jqueryUI: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/jquery-ui.custom.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            });

            return q.promise;

          }],
          fullcalendar: ['$q', '$rootScope', function($q, $rootScope) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/fullcalendar.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            });

            return q.promise;

          }]
        }
      };

    $stateProvider
      .state(resourcesInstances);
});
